import { SubscriptionDetailsResponse } from "@9amhealth/openapi";
import { Cubit } from "blac-next";
import FunnelKey from "src/constants/funnelKey";
import { determineFunnelKey } from "src/lib/determineFunnelKey";
import { StorageController } from "src/state/StorageBloc/StorageBloc";
import { subscriptionState, userPreferences } from "src/state/state";
import { UserPreferenceKeys } from "../UserPreferencesCubit/UserPreferencesCubit";

export enum AppAccessStatus {
  LOADING = "LOADING",
  GRANTED = "GRANTED",
  NEEDS_FUNNEL = "NEEDS_FUNNEL"
}

export interface AppAccessState {
  status: AppAccessStatus;
  funnelRedirectPath?: string;
  funnelKey?: FunnelKey;
}

const ACCESS_GRANTING_STATUSES = [
  SubscriptionDetailsResponse.status.ACTIVE,
  SubscriptionDetailsResponse.status.FINISHED,
  SubscriptionDetailsResponse.status.PAUSED,
  SubscriptionDetailsResponse.status.IN_REVIEW
];

export default class AppAccessCubit extends Cubit<AppAccessState> {
  static keepAlive = true;
  constructor() {
    super({
      status: AppAccessStatus.LOADING
    });
  }

  private grantAccess(): void {
    StorageController.setHasAppAccess(true);
    this.emit({
      status: AppAccessStatus.GRANTED,
      funnelRedirectPath: undefined,
      funnelKey: undefined
    });
  }

  async evaluateAccess(): Promise<void> {
    const subscriptions = subscriptionState.state.allSubscriptions ?? [];

    const hasAccessGrantingSubscription = subscriptions.some((s) =>
      ACCESS_GRANTING_STATUSES.includes(s.status)
    );
    if (hasAccessGrantingSubscription) {
      this.grantAccess();
      return;
    }

    const draftSubscription = subscriptions.find(
      (s) => s.status === SubscriptionDetailsResponse.status.DRAFT
    );

    const funnelKey = determineFunnelKey({
      draftSubscription,
      lastSignupFunnel:
        userPreferences.state[UserPreferenceKeys.lastSignupFunnel]
    });
    const params = new URLSearchParams(window.location.search);
    const queryString = params.toString();
    const funnelRedirectPath = `/signup/${funnelKey}${queryString ? `?${queryString}` : ""}`;

    this.emit({
      status: AppAccessStatus.NEEDS_FUNNEL,
      funnelRedirectPath,
      funnelKey
    });
  }

  reset(): void {
    this.emit({
      status: AppAccessStatus.LOADING,
      funnelRedirectPath: undefined,
      funnelKey: undefined
    });
  }
}
